import { Close } from "@material-ui/icons";

import { useState } from "react";
import { CallBackProps, Step, TooltipRenderProps } from "react-joyride";

import useAuthStore from "./useAuthStore";
import { firstReportEntryAreaQuerySelector } from "./useTutorial";

export interface TutorialContextType {
  run: boolean;
  started: boolean;
  setStarted: (started: boolean) => void;
  setRun: (run: boolean) => void;
  stepIndex: number;
  setStepIndex: (stepIndex: number) => void;
  steps: Step[];
  tourActive: boolean;
  setTourActive: (tourActive: boolean) => void;
  start: ({ index }: { index: number }) => void;
  pause: () => void;
}

type TooltipProps = {
  continuous: boolean;
  index: number;
  step: Step;
  backProps: TooltipRenderProps["backProps"];
  closeProps: TooltipRenderProps["closeProps"];
  primaryProps: TooltipRenderProps["primaryProps"];
  tooltipProps: TooltipRenderProps["tooltipProps"];
  isLast?: boolean;
};

export function entryCountInFirstReportEntryArea(): number {
  const entryArea = document.querySelector<HTMLDivElement>(
    firstReportEntryAreaQuerySelector
  );
  if (entryArea !== null) {
    return entryArea.childElementCount;
  }
  return 0;
}

export default function Tooltip({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  isLast = false,
}: TooltipProps) {
  const [nextButtonEnabled, setNextButtonEnabled] = useState(
    (index == 3 && entryCountInFirstReportEntryArea() >= 2) || index !== 3
  );

  if (!nextButtonEnabled && index == 3) {
    waitForCondition(
      () => entryCountInFirstReportEntryArea() >= 2,
      500,
      () => setNextButtonEnabled(true)
    );
  }

  const { accessToken } = useAuthStore();

  return (
    <div
      className="bg-white max-w-xs sm:max-w-sm text-base-300 p-4 space-y-4 rounded-lg relative"
      {...tooltipProps}
    >
      <div className="absolute top-2 right-2">
        {continuous && (
          <button {...closeProps} className={`btn btn-square btn-xs`}>
            <Close className="p-1" />
          </button>
        )}
      </div>
      {step.title && (
        <h1 className="text-lg font-bold text-center">{step.title}</h1>
      )}
      <p>{step.content}</p>
      <div className="flex flex-row justify-end space-x-4">
        {index > 0 && (
          <button {...backProps} className={`btn btn-sm`}>
            Zurück
          </button>
        )}
        {continuous && (
          <button
            {...primaryProps}
            data-accesstoken={accessToken}
            className={`btn btn-sm btn-primary ${
              !nextButtonEnabled && "!text-base-300 btn-disabled"
            }`}
          >
            {isLast ? "Fertig" : "Weiter"}
          </button>
        )}
      </div>
    </div>
  );
  function waitForCondition(
    conditionToCheck: () => boolean,
    ms: number = 500,
    callback: () => void
  ) {
    if (conditionToCheck()) {
      callback();
    } else {
      setTimeout(() => {
        waitForCondition(conditionToCheck, ms, callback);
      }, ms);
    }
  }
}
